function inventoryCompare(a, b) {
    const nameA = a.skuCode.toUpperCase(); // ignore upper and lowercase
    const nameB = b.skuCode.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB)
        return -1;
    if (nameA > nameB)
        return 1;
    // names must be equal
    return 0;
}
const allowedPaidSku = {
    US: ['process.env.GEAR_1_SKU', 'process.env.GEAR_2_SKU', 'process.env.GEAR_3_SKU'],
    CA: ['process.env.GEAR_1_CA_SKU', 'process.env.GEAR_2_CA_SKU', 'process.env.GEAR_3_CA_SKU'],
};
const allowedVipSku = [/^process.env.ONE_YEAR_VIP_SKU/, /^process.env.LIFETIME_VIP_SKU/];
const normalizeInventories = (products, country) => {
    const allowedPaid = allowedPaidSku[country || 'US'];
    if ((products === null || products === void 0 ? void 0 : products.length) > 0 && allowedPaid) {
        return products.reduce((acc, { inventories }) => {
            const paidSku = inventories.filter(i => allowedPaid.indexOf(i.skuCode) !== -1);
            const vipSku = inventories.filter(i => allowedVipSku.some((r) => r.test(i.skuCode)));
            return [
                ...acc,
                ...paidSku,
                ...vipSku,
            ];
        }, []).sort(inventoryCompare);
    }
    return [];
};
export default normalizeInventories;
